



import {Component, Vue, Prop} from 'vue-property-decorator';
import {CHECKBOX_STATUS} from "@/constants";

@Component({})
export default class CheckInputQuestion extends Vue {
  @Prop({required: false, type: String, default: ''}) label!: string
  @Prop({required: false, type: String, default: 'warning'}) color!: string
  @Prop({required: true, type: Number, default: 0}) value!: number

  private checkStatus = CHECKBOX_STATUS
  private status = CHECKBOX_STATUS.UN_ACCEPTED

  private get checkBoxLabel() {
    if (this.label) return this.label
    return ''
  }

  private onCheckboxChange(status: number): void {
    this.$emit('onChange', status, this.value)
  }
}
